import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Typography, Button } from '@material-ui/core'

import BarCodeScannerComponent from './scanner'

const BarCodeScanner = () => {
   const navigate = useNavigate()

   const { innerWidth: windowWidth } = window

   const [isActive, setIsActive] = useState(false)
   const [noCamera, setNoCamera] = useState(null)

   const buttonClicked = () => setIsActive(!isActive)

   const buttonCloseClicked = () => {
      setIsActive(!isActive)
      setNoCamera(null)
   }

   return (
      <>
         {isActive ? (
            <Box
               sx={{
                  position: 'relative',
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  width: !noCamera ? '465px' : 'auto',
                  height: !noCamera ? '300px' : 'auto'
               }}
            >
               {noCamera ? (
                  <Typography sx={{ fontSize: '24px', color: 'primary', fontWeight: '500' }}>
                     No camera found
                  </Typography>
               ) : (
                  <BarCodeScannerComponent
                     width={noCamera === null ? (windowWidth < 425 ? windowWidth * 0.9 : 400) : 0}
                     // height={300}
                     onUpdate={(err, result) => {
                        if (result) {
                           navigate('/app/product/' + result.text, { replace: true })
                           window.location.reload()
                        } else console.log(err.message)
                     }}
                     noCamera={noCamera}
                     setNoCamera={setNoCamera}
                  />
               )}
               <Button
                  className={!noCamera && 'cross-button'}
                  onClick={() => buttonCloseClicked()}
                  sx={{
                     fontWeight: '600',
                     fontSize: '30px',
                     zIndex:3
                  }}
               >
                  X
               </Button>
            </Box>
         ) : (
            <Button onClick={() => buttonClicked()} variant='contained'>
               Scan Barcode
            </Button>
         )}
      </>
   )
}

export default BarCodeScanner
